export default __webpack_public_path__ + "static/media/rocket_anim_113.539e3bc9.png";